import { Check as IconApprove, Undo as IconRevertApproval } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlWorkerVisitReportStatus } from "~/__generated__";

type Props = {
    teamReportsStatuses: GqlWorkerVisitReportStatus[] | undefined;
    onUpdate: (status: GqlWorkerVisitReportStatus) => void;
    loading: boolean;
};

export default function ApprovalButton({ teamReportsStatuses, onUpdate, loading }: Props) {
    const { t } = useTranslation("project");
    if (teamReportsStatuses === undefined || teamReportsStatuses.length < 1) return null;
    const allAwaitingApproval = teamReportsStatuses.every(s => s === GqlWorkerVisitReportStatus.AwaitingApproval);
    const allApproved = teamReportsStatuses.every(s => s === GqlWorkerVisitReportStatus.Approved);

    const nextStatus = allApproved ? GqlWorkerVisitReportStatus.AwaitingApproval : GqlWorkerVisitReportStatus.Approved;

    return (
        <Button
            disabled={!allAwaitingApproval && !allApproved}
            onClick={() => onUpdate(nextStatus)}
            loading={loading}
            color={allApproved ? "error" : "primary"}
            variant={allApproved ? "outlined" : "contained"}
            startIcon={allApproved ? <IconRevertApproval /> : <IconApprove />}
        >
            {t(
                allApproved
                    ? "projectReviewVisitV2.teamReportsRoute.approvalButton.labelRevertApproval"
                    : "projectReviewVisitV2.teamReportsRoute.approvalButton.labelApprove",
            )}
        </Button>
    );
}
